import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import useModal from '@hooks/ui/useModal';
import { useSetAtom } from 'jotai';

import DeleteAllMyMenuModal from './DeleteAllMyMenuModal';
import styles from './styles.module.scss';
import { isDeletingAtom } from '../../../atoms/myMenuAtoms';

function MyMenuSettingBottomSheet() {
    const { closeBottomSheet } = useBottomSheet();
    const { openModal } = useModal();
    const setDeleting = useSetAtom(isDeletingAtom);
    const handleDeleteAll = () => {
        closeBottomSheet();
        openModal(<DeleteAllMyMenuModal/>);
    };
    const handleStartDelete = () => {
        setDeleting(true);
        closeBottomSheet();
    };
    return (
        <Column className={styles.container}>
            <Text fontWeight='bold' size='lg' className={styles.main}>
                메인화면 노출
            </Text>
            <Checkbox>전체 숨기기</Checkbox>
            <div className={styles.note}>
                <Text color={colors.gray6}>
                    메뉴를 삭제 하지 않고 일시적으로 숨겨서 전체 리스트를 미노출시킬 수 있습니다.
                </Text>
            </div>
            <Text fontWeight='bold' size='lg'>
                메뉴 삭제
            </Text>
            <Column className={styles.remove}
                spacing={12}>
                <Text onClick={handleStartDelete}>선택 삭제</Text>
                <Text onClick={handleDeleteAll}>
                    전체 삭제
                </Text>
            </Column>
        </Column>
    );
}

export default MyMenuSettingBottomSheet;
